// src/data/processData.js

import {
  FaComments,
  FaMapMarkedAlt,
  FaDraftingCompass,
  FaHardHat,
  FaTools,
  FaClipboardCheck,
  FaFlagCheckered,
  FaCertificate,
} from "react-icons/fa";

const processData = [
  {
    id: 1,
    step: "01",
    title: "Consultation",
    description:
      "Understanding client requirements, sports type, budget and project objectives.",
    icon: FaComments,
  },

  {
    id: 2,
    step: "02",
    title: "Site Inspection",
    description:
      "Detailed site survey, measurements and feasibility analysis before construction.",
    icon: FaMapMarkedAlt,
  },

  {
    id: 3,
    step: "03",
    title: "Design & Planning",
    description:
      "Preparing layouts, technical drawings, material selection and project planning.",
    icon: FaDraftingCompass,
  },

  {
    id: 4,
    step: "04",
    title: "Ground Preparation",
    description:
      "Earthwork, leveling, drainage system and strong base construction.",
    icon: FaHardHat,
  },

  {
    id: 5,
    step: "05",
    title: "Surface Installation",
    description:
      "Installation of Acrylic, PU, EPDM, Synthetic Turf and other sports surfaces.",
    icon: FaTools,
  },

  {
    id: 6,
    step: "06",
    title: "Quality Inspection",
    description:
      "Performance testing, quality checks and final finishing before delivery.",
    icon: FaClipboardCheck,
  },

  {
    id: 7,
    step: "07",
    title: "Project Handover",
    description:
      "Final walkthrough, client approval and successful handover of the completed facility.",
    icon: FaFlagCheckered,
  },

  {
    id: 8,
    step: "08",
    title: "Certificate",
    description: "Official Class 1 and Class 2 sports court certifications.",
    icon: FaCertificate,
  },
];

export default processData;
